<template>
  <div class="product-formats">
    <h2 class="title">FORMATO</h2>
    <div class="formats">
      <button 
        class="btn btn-light" 
        v-for="format in formats" 
        :key="format.CODFORMATO"
        @click="selectFormat"
      >{{ format.DESCRIPCION }}</button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    formats: { required: true }
  },
  data() {
    return {
      current: {}
    }
  },
  methods: {
    selectFormat(format) {
      this.current = format
      this.$emit('selectFormat', format)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Order/OrderAddProductModal/ProductFormats.vue